<eps-filter-list
  header="SHARED.HEADER.INVOICES"
  [displayedColumns]="['soldTo', 'invoiceNumber','invoiceDate','currency', 'netAmount','vatAmount','totalAmount']"
  filterButtonLabel="INVOICES.FILTER.BUTTONS.FILTER_TEXT"
  [tableHeaderButtons]="downloadExcelListButton"
  paginatorPosition="both"
  [list]="invoices"
  [loading]="loading"
  [localDataPaging]="false"
  [pageSizeOptions]="[10,25,50]"
  [executeDisabled]="!filterValid"
  (filterOrPagingChanged)="filterInvoices($event)"
  (rowClicked)="openInvoice($event)"
  [paging]="paging"
  @fadeInAnimation
>
  <ng-container filter-buttons>
    <eps-button
      label="SHARED.BUTTONS.CLEAR_FILTERS"
      (buttonClick)="onClearFilter()"
      ></eps-button>
  </ng-container>

  <ng-container filter>
    <invoices-filter
      [loading]="false"
      [busy]="false"
      [soldTos]="sandbox.soldTos$ | async"
      [invoiceTypes]="sandbox.invoiceTypes$ | async"
      [showSelectCustomers]="sandbox.isSuperUser$ | async"
      [clearFilter]="clearFilter"
      (filterChanged)="setFilter($event)"
    ></invoices-filter>
  </ng-container>

  <ng-template table-column column="soldTo" label="INVOICES.LIST.LABELS.SOLD_TO" [sort]="true" let-invoice>
    <span class="soldTo">
      <eps-select
        [options]="sandbox.soldTos$ | async"
        [value]="invoice.soldToId"
        readonly
      ></eps-select>
    </span>
  </ng-template>

  <ng-template table-column column="invoiceNumber" label="INVOICES.LIST.LABELS.NUMBER" [sort]="true" let-invoice>
    {{invoice.invoiceNumber}}
  </ng-template>

  <ng-template table-column column="invoiceDate" label="INVOICES.LIST.LABELS.DATE" [sort]="true" let-invoice>
    {{invoice.invoiceDate | date: dateFormat}}
  </ng-template>

  <ng-template table-column column="netAmount" label="INVOICES.LIST.LABELS.NET_AMOUNT" [sort]="true" let-invoice>
    <span class="amount" [ngClass]="{negative: invoice.netAmount < 0}">{{invoice.netAmount  | number: '1.2-2': 'fr-FR'}}</span>
  </ng-template>

  <ng-template table-column column="vatAmount" label="INVOICES.LIST.LABELS.VAT_AMOUNT" [sort]="true" let-invoice>
    <span class="amount" [ngClass]="{negative: invoice.vatAmount < 0}">{{invoice.vatAmount  | number: '1.2-2': 'fr-FR'}}</span>
  </ng-template>

  <ng-template table-column column="totalAmount" label="INVOICES.LIST.LABELS.TOTAL" [sort]="true" let-invoice>
    <span class="amount" [ngClass]="{negative: invoice.totalAmount < 0}">{{invoice.totalAmount  | number: '1.2-2': 'fr-FR'}}</span>
  </ng-template>
  <ng-template table-column column="currency" label="INVOICES.LIST.LABELS.CURRENCY" [sort]="true" let-invoice>
    {{invoice.currency}}
  </ng-template>
</eps-filter-list>
